import {
  initialState,
  Actions,
  State,
  GET_ALL_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS_SUCCESS,
  GET_ALL_NOTIFICATIONS_ERROR,
  RESET_GET_ALL_NOTIFICATIONS,
} from "../../types/notification/all";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_NOTIFICATIONS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_NOTIFICATIONS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
